import React from 'react'
import clsx from 'clsx'
import Image from './Image'
import Other from './Other'
import SimpleAudioPlayer from './Audio'
import useStyles from './styles'

const MediaElement = ({ media, observer, isYours }) => {
  const [images, setImages] = React.useState([])
  const [otherMedia, setOtherMedia] = React.useState([])
  const [showMore, setShowMore] = React.useState([])
  const [resetChunks, setResetChunks] = React.useState(false)
  const [overlay, setOverlay] = React.useState(false)

  const classes = useStyles({ images, otherMedia })

  // setting images and media into appropriate arrays for display
  React.useEffect(() => {
    const images = []
    const otherMedia = []
    if (media?.length) {
      media.forEach(m => {
        if (m.type === 'image') {
          images.push(m)
        } else {
          otherMedia.push(m)
        }
      })
    }

    setImages(images)
    setOtherMedia(otherMedia)
  }, [media])

  React.useEffect(() => {
    if (resetChunks) {
      setShowMore([...images])
      setOverlay(false)
    }
  }, [resetChunks, images])

  React.useEffect(() => {
    if (images.length > 4) {
      const imgs = [...images]
      imgs.pop()

      setShowMore([...imgs])
      setOverlay(true)
    } else {
      setShowMore([...images])
    }
  }, [images])

  return (
    <>
      <div
        className={clsx(
          classes.root,
          images.length > 1 && images.length !== 2 && classes.setWidth,
          showMore.length > 4 && classes.grid,
          images.length === 2 && classes.twoImages
        )}
      >
        {showMore.map((c, i) => (
          <Image
            key={`${c.id}-${i}`}
            media={c}
            observer={observer}
            overlay={i === 3 && overlay}
            number={overlay && images.length - showMore.length}
            setResetChunks={setResetChunks}
            className={classes.parent}
          />
        ))}
      </div>

      {otherMedia.map((m, i) => {
        if (m?.type === 'audio') {
          return <SimpleAudioPlayer key={`${m.id}-${i}`} media={m} />
        }
        return (
          <Other
            key={`${m.id}-${i}`}
            media={m}
            length={otherMedia.length}
            imgsLength={images.length}
            isYours={isYours}
          />
        )
      })}
    </>
  )
}

export default MediaElement
